import { SOFTWARE_PROJECT } from '@jira/platform__project-types/src/project-types.tsx';
import { PREMIUM_EDITION } from '@jira/platform__application-editions/src/edition.tsx';
import { SOFTWARE } from '@atlassian/jira-shared-types/src/application-key.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { useGetBillingPageUrl } from '../get-billing-page-url/index.tsx';

type UseJswPremiumTrialUpgradeLink = { deepLink?: boolean; skip?: boolean; caller: string };

export const useJswPremiumTrialUpgradeLink = ({
	deepLink = true,
	skip = false,
	caller,
}: UseJswPremiumTrialUpgradeLink) => {
	const { productEntitlementDetails } = useTenantContext();
	const jswEntitlement = productEntitlementDetails?.[SOFTWARE];
	const isJswUsingCcp = jswEntitlement?.billingSourceSystem === 'CCP';
	const { data, ...rest } = useGetBillingPageUrl({
		isUsingCcp: isJswUsingCcp,
		editionToUpgradeTo: deepLink ? PREMIUM_EDITION : undefined,
		caller,
		skip,
		subProduct: SOFTWARE_PROJECT,
	});

	return {
		data: { premiumTrialUpgradeLink: data.billingPageUrl },
		...rest,
	};
};
